import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

@Injectable()
export class TrabajadoresService implements OnInit
{
    private authorization : string =
      "";
    constructor(
      private http: HttpClient,
      private session: Session,
      private dataService: DataService
    ){
      this.authorization += session.idToken;
    }

    ngOnInit(){}
    listar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/trabajadores/listar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarDocumentosAdjuntos(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);      
      formData.append('accessToken', this.session.currentUser.accessToken);
      this.http
      .post(
        Constants.API_BASE + "/trabajadores/listarDocumentosAdjuntos",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarDocumentos(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);      
      formData.append('accessToken', this.session.currentUser.accessToken);
      this.http
      .post(
        Constants.API_BASE + "/trabajadores/listarDocumentos",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarCamposDisponibles(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);      
      formData.append('accessToken', this.session.currentUser.accessToken);
      this.http
      .post(
        Constants.API_BASE + "/trabajadores/listarCamposDisponibles",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    crearDocumento(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);      
      formData.append('accessToken', this.session.currentUser.accessToken);
      this.http
      .post(
        Constants.API_BASE + "/trabajadores/crearDocumento",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    agregarDocumento(datos : any, callback: any){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/trabajadores/agregarDocumento",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    crear(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/trabajadores/crear",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    subirFoto(imagen, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(imagen);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/trabajadores/subirFoto",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarPorAPRDeshabilitados(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/listarPorAPRDeshabilitados",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    detallesAPR(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/detallesAPR",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    crearAPR(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/crearAPR",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/editarUsuario",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    deshabilitar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/deshabilitar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    reconfigurarPassword(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/reconfigurarPassword",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    habilitar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/habilitar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    reporteExcel(form){
      form.action= Constants.API_BASE + "/apr/reporteExcel";
      form.elements[0].value = this.session.currentUser.accessToken;
      form.elements[0].name = 'accessToken';
      form.submit();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/trabajadores/trabajadores.service.ts